﻿import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import NullableTextObservable from "../observables/nullabletextobservable";
import ko from 'knockout';
import $ from 'jquery';


export class DateInputBinder implements IBinder {
  public getElements(row: JQuery): JQuery {
    return row.find("[data-datefield]");
  }

  public getBinding(cell: JQuery): ICellBinding {
    var cellName = cell.attr("name");

    return {
      dataName: cellName,
      dataValue: new NullableTextObservable(cell.val()),
      bindingName: "init, rustigDate",
      bindTo: cellName,
      createEmptyValue: () => new NullableTextObservable()
    }
  }
}


ko.bindingHandlers.rustigDate = {
  init: (el, valueAccessor, bindingsAccessor, viewModel) => {
    var $el: any = $(el),
      value = valueAccessor();

    /*
     * bind directly to bootstrap-datepicker change event.
     * bootstrap-datepicker suppresses this event if the the date field is edited but the value is unchanged
     * this causes a bug where the knockout viewmodel object receives an incorrect value rather than the final auto-completed value.
     */
    $el.on('dp.change', (e) => {
      value($el.val());
    });
  }
};
